import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getAllRows } from "./ReportElementHelper";

class PropertyDeed extends Component {
  componentDidMount() {}

  render() {
    const node = this.props.deedNode;
    if (node === undefined) return null;
    const recs = [];
    getAllRows(node, recs, this.props, _.get(node, "$.display"));

    return (
      <Table>
        <Table.Body>
          <Table.Row>
            <Table.HeaderCell
              colSpan={2}
              className="report-sub-sub-section-header"
            >
              <center>Deed Information</center>
            </Table.HeaderCell>
          </Table.Row>
          {recs}
        </Table.Body>
      </Table>
    );
  }
}

export default PropertyDeed;



// WEBPACK FOOTER //
// ./src/components/reports/PropertyDeed.js